<template>
  <v-form v-model="isValid" class="d-flex flex-column align-center justify-center">
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ matriculationNrQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="matriculationNr"
          :rules="matriculationNrQuestion.rules"
          :placeholder="matriculationNrQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ registrationNrQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="registrationNr"
          :rules="registrationNrQuestion.rules"
          :placeholder="registrationNrQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ brandQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="brand"
          :rules="brandQuestion.rules"
          :placeholder="brandQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ modelQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="model"
          :rules="modelQuestion.rules"
          :placeholder="modelQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ bodyNrQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="bodyNr"
          :rules="bodyNrQuestion.rules"
          :placeholder="bodyNrQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ manufactureYearQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="manufactureYear"
          :rules="manufactureYearQuestion.rules"
          :placeholder="manufactureYearQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ vehicleTypeQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          :value="vehicleType ? vehicleType.text : null"
          dense
          filled
          rounded
          solo
          flat
          readonly
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ cylindricalCapacityQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="cylindricalCapacity"
          :rules="cylindricalCapacityQuestion.rules"
          :placeholder="cylindricalCapacityQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
  </v-form>
</template>

<script>
import { vehicleQuestions } from '@/_utils/static-data';
export default {
  name: 'CompleteVehicleForm',
  props: {
    vehicleType: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      matriculationNr: null,
      registrationNr: null,
      brand: null,
      model: null,
      bodyNr: null,
      manufactureYear: null,
      cylindricalCapacity: null,
      isValid: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    matriculationNrQuestion() {
      return this.getQuestionById(9);
    },
    registrationNrQuestion() {
      return this.getQuestionById(2);
    },
    brandQuestion() {
      return this.getQuestionById(3);
    },
    modelQuestion() {
      return this.getQuestionById(4);
    },
    bodyNrQuestion() {
      return this.getQuestionById(5);
    },
    manufactureYearQuestion() {
      return this.getQuestionById(6);
    },
    vehicleTypeQuestion() {
      return this.getQuestionById(7);
    },
    cylindricalCapacityQuestion() {
      return this.getQuestionById(8);
    }
  },
  methods: {
    getQuestionById(id) {
      return vehicleQuestions(id)?.[0];
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateData', {
          data: [
            {
              questionText: this.matriculationNrQuestion.text,
              text: this.matriculationNr
            },
            {
              questionText: this.registrationNrQuestion.text,
              text: this.registrationNr
            },
            {
              questionText: this.brandQuestion.text,
              text: this.brand
            },
            {
              questionText: this.modelQuestion.text,
              text: this.model
            },
            {
              questionText: this.bodyNrQuestion.text,
              text: this.bodyNr
            },
            {
              questionText: this.manufactureYearQuestion.text,
              text: this.manufactureYear
            },
            {
              questionText: this.vehicleTypeQuestion.text,
              text: this.vehicleType?.text || null
            },
            {
              questionText: this.cylindricalCapacityQuestion.text,
              text: this.cylindricalCapacity
            }
          ],
          isValid: this.isValid
        });
      });
    }
  }
};
</script>

<style scoped>
.text-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input {
  border: none;
}
.field-label {
  width: 150px;
}
@media screen and (max-width: 600px) {
  .field-label {
    width: 100%;
  }
  .text-input, .dropdown-input {
    width: 100%;
    min-width: 260px;
  }
}
</style>
